import { FSArticle } from "../data/repositories/fastcalculator-calculation/mapper"

export const isTruncatedOeArticle = (article?: FSArticle) => {
    return !article?.oeNrs?.[0]?.length || !article?.oeLabel?.length
}